export const handle = (error, customMessage) => {
  console.log(error.message);
  if (customMessage) {
    alert(customMessage);
  } else {
   /* alert("Ha ocurrido un problema, intentalo más tarde.");*/
  }
};
